import React from "react";
import GetStartedBtn from "./button";
import "./manage.css";
import "./button.css";
import illustration from "../images/illustration-intro.svg";

const Section1 = (props) => {
  window.addEventListener("load", () => {
    document.querySelector("body").classList.add("loaded");
  });
  return (
    <div className="section1-container">
      <div className="header1">
        <h1>
          Bring everyone <br /> together to build <br /> better products.
        </h1>
        <p>
          Manage makes it simple for software teams to plan day-to-day tasks
          while keeping the larger team golas in view.
        </p>
        <div className="button-container header-btn-container">
          <GetStartedBtn btn="manage-btn body-btn" />
        </div>
      </div>
      <div className="header2">
        <img src={illustration} alt="" />
      </div>
    </div>
  );
};

export default Section1;
